import { useMutation, gql } from '@apollo/client';

import { GET_INTERVIEW_TYPES } from './get-interview-types.hook';

export const CREATE_INTERVIEW_TYPE = gql`
  mutation createInterviewType($payload: InterviewTypeInput!) {
    createInterviewType(payload: $payload) {
      _id
    }
  }
`;

export const useCreateInterviewType = () => {
  const [createInterviewType] = useMutation(CREATE_INTERVIEW_TYPE, {
    refetchQueries: [GET_INTERVIEW_TYPES],
  });

  return createInterviewType;
};
